import React from 'react';

import { ConfigContext } from 'root/apps/contexts/ConfigContext';
import { UserPreferencesContext } from 'root/apps/contexts/UserPreferencesContext';
import { PartitionCollapseToggleViewInner } from 'root/apps/Partition/PartitionCollapseToggle/PartitionCollapseToggleViewInner';

export const PartitionCollapseToggleView: React.FC = () => {
  const { getConfig } = React.useContext(ConfigContext);
  const { getUserPreferenceValueByName, updateUserPreferenceValueByName } =
    React.useContext(UserPreferencesContext);

  const partitionName = getConfig('partitionName');
  if (!partitionName) return null;

  const title = getConfig('title', partitionName);
  const userPreferenceName = getConfig('userPreferenceName');
  const isCollapsed =
    (userPreferenceName && getUserPreferenceValueByName(userPreferenceName) === 'hide') ?? false;

  const handleToggle = (collapsed: boolean) => {
    if (!userPreferenceName) return;
    updateUserPreferenceValueByName(userPreferenceName, collapsed ? 'hide' : 'show');
  };

  return (
    <PartitionCollapseToggleViewInner
      partitionName={partitionName}
      title={title}
      isCollapsed={isCollapsed}
      onToggle={handleToggle}
    />
  );
};
